module.exports = __webpack_public_path__ + "static/media/wemi_baf_famiglie.1c3af252.pdf";